import { makeAutoObservable } from 'mobx';
import apolloClient from 'api/apolloClient';
import { GET_EXCHANGE_READY_FILES } from 'api/queries/ediService';
import { EdiFile } from 'types/ediService';

export default class EdiStore {
  // eslint-disable-next-line class-methods-use-this
  async getExchangeReadyFiles(sponsorId: string, setAsSent?: boolean): Promise<EdiFile[]> {
    const res = await apolloClient.query<{ getExchangeReadyFiles: EdiFile[] }>({
      query: GET_EXCHANGE_READY_FILES,
      fetchPolicy: 'no-cache',
      variables: { sponsorId, setAsSent },
    });
    return res.data.getExchangeReadyFiles;
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
